import React from "react";

/**
 * Nav icon set. Stroked line icons that inherit `currentColor`, so a nav item
 * only has to set its own text colour — no separate active/inactive assets.
 */

const base = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
};

export const DashboardGlyph = () => (
  <svg {...base}>
    <rect x="3" y="3" width="7.5" height="8.5" rx="2" />
    <rect x="13.5" y="3" width="7.5" height="5.5" rx="2" />
    <rect x="13.5" y="12.5" width="7.5" height="8.5" rx="2" />
    <rect x="3" y="15.5" width="7.5" height="5.5" rx="2" />
  </svg>
);

export const ReportGlyph = () => (
  <svg {...base}>
    <path d="M3 20h18" />
    <path d="M6.5 20v-6" />
    <path d="M12 20V6" />
    <path d="M17.5 20v-9" />
  </svg>
);

export const CampaignGlyph = () => (
  <svg {...base}>
    <path d="M3.5 9.5v5a1.5 1.5 0 0 0 1.5 1.5h2l7 4.5V5L7 9.5H5a1.5 1.5 0 0 0-1.5 1.5Z" />
    <path d="M18 9a4.5 4.5 0 0 1 0 6" />
  </svg>
);

export const AdvertiserGlyph = () => (
  <svg {...base}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3.5 20a5.5 5.5 0 0 1 11 0" />
    <path d="M16.5 6.2a3 3 0 0 1 0 5.6" />
    <path d="M18 20a5.2 5.2 0 0 0-2.6-4.5" />
  </svg>
);

export const PublisherGlyph = () => (
  <svg {...base}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 3v3.5M12 17.5V21M3 12h3.5M17.5 12H21" />
    <path d="M5.6 5.6 8 8M16 16l2.4 2.4M18.4 5.6 16 8M8 16l-2.4 2.4" />
  </svg>
);

export const BillingGlyph = () => (
  <svg {...base}>
    <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
    <path d="M2.5 10h19" />
    <path d="M6.5 14.5h4" />
  </svg>
);

export const PostbackGlyph = () => (
  <svg {...base}>
    <path d="M4 8h11.5a4.5 4.5 0 0 1 0 9H9" />
    <path d="m7.5 4.5-3.5 3.5 3.5 3.5" />
    <path d="m11.5 13.5-2.5 3.5 2.5 3.5" />
  </svg>
);

export const ProfileGlyph = () => (
  <svg {...base}>
    <circle cx="12" cy="8" r="3.5" />
    <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
  </svg>
);

export const NotificationGlyph = () => (
  <svg {...base} width="18" height="18">
    <path d="M6 9a6 6 0 1 1 12 0c0 3.2.8 5 1.6 6H4.4C5.2 14 6 12.2 6 9Z" />
    <path d="M10 19a2 2 0 0 0 4 0" />
  </svg>
);
